import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  ICliente,
  TipoHabilitacion,
  IActivo,
  IDispositivoAlarma,
  IUpdateDispositivoAlarma,
  IUpdateActivo,
  ICodigoDispositivo,
  IParticionZona,
} from 'modelos/src';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { ParamsService } from '../../../auxiliares/servicios/params.service';
import { AlarmasDomiciliariasService } from '../../entidades/alarmas/alarmas-domiciliarias/alarmas-domiciliarias.service';
import { ActivosService } from '../../../auxiliares/servicios/http/activos.service';
import { DateRange } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { CardHeaderComponent } from '../../../componentes/card-header/card-header.component';

@Component({
  imports: [AuxiliaresModule, InfoBannerComponent, CardHeaderComponent],
  selector: 'app-modo-desactivado-dispositivo',
  templateUrl: './modo-desactivado-dispositivo.component.html',
  styleUrl: './modo-desactivado-dispositivo.component.scss',
})
export class ModoDesactivadoDispositivoComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<ModoDesactivadoDispositivoComponent>>(MatDialogRef);
  data = inject<{
    alarma?: IDispositivoAlarma;
    activo?: IActivo;
  }>(MAT_DIALOG_DATA);
  helper = inject(HelperService);
  private serviceAlarma = inject(AlarmasDomiciliariasService);
  private serviceActivo = inject(ActivosService);
  dialog = inject(MatDialog);
  paramsService = inject(ParamsService);

  public loading = false;
  public form?: FormGroup;
  public title?: string = 'Modo desactivado';
  public permanente?: boolean = true;
  public dispositivo?: IDispositivoAlarma | IActivo;
  public nombreDispositivo?: string;
  public codigos?: ICodigoDispositivo[];
  public todosLosEventos: boolean = false;
  public particionesDisponibles: number[] = [];
  public particionesSeleccionadas: number[] = [];
  public infoZonas: IParticionZona[] = [];
  public zonasSeleccionadas: IParticionZona[] = [];
  public clientes?: ICliente[] = [];

  public tiposHabilitacion: TipoHabilitacion[] = ['Siempre', 'Con Evento'];

  get alarma() {
    return this.form?.get('alarma') as FormGroup;
  }

  get isDispositivoDesactivado(): boolean {
    if (this.form?.get('dispositivoDesactivado')?.value !== true) return false;
    const md = this.dispositivo?.modoDesactivado;
    if (md?.permanente) return true;
    if (!md?.hasta) return true;
    return new Date(md.hasta) > new Date();
  }

  public range?: DateRange = {};

  private createForm() {
    this.form = new FormGroup({
      dispositivoDesactivado: new FormControl(
        this.dispositivo?.modoDesactivado?.dispositivoDesactivado
          ? this.dispositivo?.modoDesactivado?.dispositivoDesactivado
          : false,
      ),
      desde: new FormControl(this.dispositivo?.modoDesactivado?.desde),
      hasta: new FormControl(this.dispositivo?.modoDesactivado?.hasta),
      permanente: new FormControl(
        this.dispositivo?.modoDesactivado?.permanente === true ? true : false,
      ),
      codigos: new FormControl(this.dispositivo?.modoDesactivado?.codigos),
    });
  }

  //

  public searchCodigo = (term: string, item: ICodigoDispositivo) => {
    if (item.codigo?.toLowerCase().includes(term.toLowerCase())) return true;
    if (item.descripcion?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  public searchZona = (term: string, item: IParticionZona) => {
    const s = term.toLowerCase();
    if (item.nombre?.toLowerCase().includes(s)) return true;
    if (String(item.particion).includes(s)) return true;
    if (String(item.zona).includes(s)) return true;
    return false;
  };

  //
  public async onSubmit() {
    this.loading = true;
    try {
      const data = this.getData();
      data.modoDesactivado.dispositivoDesactivado =
        !this.isDispositivoDesactivado;
      if (this.dispositivo?._id) {
        // Update
        let res;
        if (this.data.alarma)
          res = await this.serviceAlarma.update(this.dispositivo._id, data);
        if (this.data.activo) {
          res = await this.serviceActivo.update(this.dispositivo._id, data);
        }
        this.helper.notifSuccess('Actualizado correctamente');
        this.volver(res);
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public getData(): IUpdateDispositivoAlarma | IUpdateActivo {
    const data: IUpdateDispositivoAlarma | IUpdateActivo = {
      modoDesactivado: this.form?.getRawValue(),
    };
    if (!data.modoDesactivado.permanente) {
      data.modoDesactivado.desde = this.range?.start;
      data.modoDesactivado.hasta = this.range?.end;
    } else {
      data.modoDesactivado.desde = '';
      data.modoDesactivado.hasta = '';
    }
    if (this.todosLosEventos) {
      // Todos los eventos: limpiar filtros específicos
      data.modoDesactivado.codigos = [];
      if (this.data.alarma) {
        data.modoDesactivado.alarma = { particiones: [], zonas: [] };
      }
    } else {
      // Eventos específicos: guardar codigos del form + particiones/zonas de los chips
      if (this.data.alarma) {
        if (!data.modoDesactivado.alarma) data.modoDesactivado.alarma = {};
        data.modoDesactivado.alarma.particiones =
          this.particionesSeleccionadas.map(String);
        data.modoDesactivado.alarma.zonas = this.zonasSeleccionadas.map(
          (z) => ({
            particion: String(z.particion),
            zona: String(z.zona),
          }),
        );
      }
    }

    return data;
  }

  public volver(res?: any) {
    if (this.dialogRef) {
      this.dialogRef.close(res);
    } else {
      HelperService.volver();
    }
  }

  async ngOnInit() {
    if (this.data?.activo) {
      this.dispositivo = this.data.activo;
      this.codigos = this.data.activo.tracker?.modelo?.codigos?.codigos;
    } else {
      this.dispositivo = this.data?.alarma;
      this.codigos = this.data.alarma?.modelo?.codigos?.codigos;
      this.infoZonas = this.data.alarma?.infoZonas || [];
      this.particionesDisponibles = [
        ...new Set(
          this.infoZonas
            .map((z) => z.particion)
            .filter((p): p is number => p !== undefined),
        ),
      ].sort((a, b) => a - b);
      if (
        this.dispositivo.modoDesactivado &&
        this.dispositivo.modoDesactivado.alarma
      ) {
        if (this.dispositivo.modoDesactivado.alarma.particiones) {
          this.particionesSeleccionadas =
            this.dispositivo.modoDesactivado.alarma.particiones
              .map(Number)
              .filter((p) => this.particionesDisponibles.includes(p));
        }
        if (this.dispositivo.modoDesactivado.alarma.zonas) {
          this.zonasSeleccionadas =
            this.dispositivo.modoDesactivado.alarma.zonas
              .map((z) =>
                this.infoZonas.find(
                  (iz) => iz.particion === +z.particion && iz.zona === +z.zona,
                ),
              )
              .filter((iz): iz is IParticionZona => iz !== undefined);
        }
      }
    }
    this.createForm();

    // Deshabilitar controles del formulario si el dispositivo está desactivado
    if (this.dispositivo?.modoDesactivado?.dispositivoDesactivado) {
      this.form?.get('permanente')?.disable();
      this.form?.get('codigos')?.disable();
    }

    const hasSpecificFilters =
      (this.dispositivo.modoDesactivado?.codigos?.length ?? 0) > 0 ||
      (this.dispositivo.modoDesactivado?.alarma?.particiones?.length ?? 0) >
        0 ||
      (this.dispositivo.modoDesactivado?.alarma?.zonas?.length ?? 0) > 0;
    this.todosLosEventos = !hasSpecificFilters;
    if (
      this.dispositivo?.modoDesactivado?.desde ||
      this.dispositivo?.modoDesactivado?.hasta
    ) {
      this.range = {
        start: this.dispositivo.modoDesactivado?.desde,
        end: this.dispositivo.modoDesactivado?.hasta,
      };
    } else if (!this.dispositivo?.modoDesactivado?.dispositivoDesactivado) {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.range = { start: now.toISOString(), end: tomorrow.toISOString() };
    }

    this.nombreDispositivo =
      this.data.alarma?.nombre || this.data.activo?.identificacion;
  }
}
